import { jsx as _jsx } from "react/jsx-runtime";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { EventsThemeShape } from "@faire/web--source/slate/Theme/EventsThemeShape";
import { observer } from "mobx-react";
import * as React from "react";
import { EventsStore } from "@faire/retailer-visitor-shared/stores/domain/Events/shared/EventsStore";
var EventIconBase = function(props) {
    var _EventsStore_get_nextOrActiveEventTheme_eventIcon, _EventsStore_get_nextOrActiveEventTheme;
    var _props_customIcon, _ref;
    var EventThemeIcon = (_ref = (_props_customIcon = props.customIcon) !== null && _props_customIcon !== void 0 ? _props_customIcon : (_EventsStore_get_nextOrActiveEventTheme = EventsStore.get().nextOrActiveEventTheme) === null || _EventsStore_get_nextOrActiveEventTheme === void 0 ? void 0 : (_EventsStore_get_nextOrActiveEventTheme_eventIcon = _EventsStore_get_nextOrActiveEventTheme.eventIcon) === null || _EventsStore_get_nextOrActiveEventTheme_eventIcon === void 0 ? void 0 : _EventsStore_get_nextOrActiveEventTheme_eventIcon.Component) !== null && _ref !== void 0 ? _ref : EventsThemeShape.faireMarket.badge;
    var _props_size;
    var size = (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : getSpacing("2x");
    return /*#__PURE__*/ _jsx(EventThemeIcon, {
        "data-test-id": "event-icon",
        width: size,
        height: size,
        className: props.className
    });
};
export var EventIcon = observer(EventIconBase);
